<script lang="ts">
    export let cssClass = '';
</script>

<div role="row"
     class="kp-generic-grid-row {cssClass}">
    <slot/>
</div>

<style lang="less">
    .kp-generic-grid-row {
        display: flex;
    }
</style>